import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = (id) => `${API_URL}/api/conditions/${id}`

const patchCondition = (accessToken, id, data) => Axios.patch(ENDPOINT(id), data, {
  headers: { 'Access-Token': accessToken },
})

export default {
  patchCondition,
}
